export default "__VITE_ASSET__1c9e9ddd__"